import React from 'react'
import PropTypes from 'prop-types'

export const AttenButtons = ({ card, markAttendance, freezAttendance }) => {
  return (
    <>
      {freezAttendance ? (
        <>
          {card.attendance.length > 0 ? (
            <button
              className={`trtui-btn trtui-btn-sm trtui-btn-${(card.attendanceType && card.attendanceType === 'p') || card.attendance.length > 0 ? 'success' : 'light'} trtui-btn-icon trtui-mr-2`}
              disabled={card.attendanceType && card.attendanceType === 'p' ? true : false}
            >
              <i className="ri-check-line" />
            </button>
          ) : (
            <button
              className={`trtui-btn trtui-btn-sm trtui-btn-${(card.attendanceType && card.attendanceType === 'a') || card.attendance.length <= 0 ? 'danger' : 'light'} trtui-btn-icon trtui-mr-2`}
              disabled={card.attendanceType && card.attendanceType === 'a' ? true : false}
            >
              <i className="ri-close-line" />
            </button>
          )}
        </>
      ) : (
        <>
          <button
            className={`trtui-btn trtui-btn-sm trtui-btn-${card.attendanceType && card.attendanceType === 'a' ? 'danger' : 'success'} trtui-btn-icon trtui-mr-2`}
            onClick={() => markAttendance(card, 'a')}
            disabled={card.attendanceType && card.attendanceType === 'a' ? true : false}
          >
            {card.attendanceType && card.attendanceType === 'a' ? (
              <i className="ri-close-line" />
            ) : (
              <i className="ri-check-line" />
            )}
          </button>
        </>
      )}
    </>
  )
}

AttenButtons.propTypes = {
  card: PropTypes.object,
  markAttendance: PropTypes.func,
  freezAttendance: PropTypes.bool,
}
